module.exports = __webpack_public_path__ + "img/03在线监测预警公众号.400c1e82.jpg";